import React from 'react';

import Classes from './Style.module.css';

const Index = () => {
  return (
    <div className={Classes.loader_container}>
      <div className={Classes.loader}></div>
    </div>
  );
};

export default Index;
